import { useEffect, useRef } from 'react';

interface AdSlotProps {
  slot: 'header' | 'sidebar' | 'in-article' | 'footer';
  className?: string;
}

// Ad slot IDs from your Google AdSense dashboard (adsense.google.com → Ads → By ad unit)
// Replace each XXXXXXXXXX with the numeric slot ID for that placement
const AD_SLOTS: Record<string, string> = {
  header:     'XXXXXXXXXX', // Header / leaderboard unit
  sidebar:    'XXXXXXXXXX', // Sidebar rectangle unit
  'in-article': 'XXXXXXXXXX', // In-article unit
  footer:     'XXXXXXXXXX', // Footer leaderboard unit
};

export default function AdSlot({ slot, className = '' }: AdSlotProps) {
  const insRef = useRef<HTMLModElement>(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    pushed.current = true;
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
    } catch {
      // adsbygoogle not loaded yet — safe to ignore
    }
  }, []);

  return (
    <div className={`w-full overflow-hidden ${className}`} aria-label="Advertisement">
      <ins
        ref={insRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-2698824285056948"
        data-ad-slot={AD_SLOTS[slot]}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}
